module.exports = __webpack_public_path__ + "static/media/checkmark-inside-circle.9d15da53.svg";